import { useEffect, useState } from 'react';

interface PetalConfig {
  left: number;
  duration: number;
  delay: number;
  size: number;
  drift: number;
}

/** 桜の花びらが舞う背景。クライアント側でランダム生成してレンダリング。 */
export function SakuraBackground({ count = 18 }: { count?: number }) {
  const [petals, setPetals] = useState<PetalConfig[]>([]);

  useEffect(() => {
    const arr: PetalConfig[] = [];
    for (let i = 0; i < count; i++) {
      arr.push({
        left: Math.random() * 100,
        duration: 8 + Math.random() * 8,
        delay: Math.random() * 10,
        size: 10 + Math.random() * 10,
        drift: -50 + Math.random() * 100,
      });
    }
    setPetals(arr);
  }, [count]);

  return (
    <div className="sakura-bg" aria-hidden>
      {petals.map((p, i) => (
        <span
          key={i}
          className="sakura-bg__petal"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            ['--drift' as string]: `${p.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
